import React, {Fragment, useState} from 'react';
import Grid from '@material-ui/core/Grid';
import {Link} from 'react-router-dom'

import Portfolio1 from "../../../images/portfolio/p1.jpg";
import Portfolio2 from "../../../images/portfolio/p2.jpg";
import Portfolio3 from "../../../images/portfolio/p3.jpg";
import Portfolio4 from "../../../images/portfolio/p4.jpg";
import Portfolio5 from "../../../images/portfolio/p5.jpg";
import Portfolio6 from "../../../images/portfolio/p6.jpg";
import Portfolio7 from "../../../images/portfolio/p7.jpg";

const portfolio = [
    {
        id: 1,
        category: 'gladki',
        image: Portfolio1
    },
    {
        id: 2,
        category: 'zebrowany',
        image: Portfolio2
    },
    {
        id: 3,
        category: 'gladki',
        image: Portfolio3
    },
    {
        id: 4,
        category: 'zebrowany',
        image: Portfolio4
    },
    {
        id: 5,
        category: 'gladki',
        image: Portfolio5
    },
    {
        id: 6,
        category: 'zebrowany',
        image: Portfolio6
    },
    {
        id: 7,
        category: 'gladki',
        image: Portfolio7
    },
];

function searchFilter(row, category) {
    return row.category.toLowerCase().includes(category.toLowerCase()) || !category;
}

const OurPortfolio = () => {
    const [category, setCategory] = useState('');
    const [isOpen, setOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);
    const [visible, setVisible] = useState(6);

        function onOpenHandler(id) {
        setOpen(true);
        setPhotoIndex(id - 1);
    }

    function loadMoreHandler() {
        setVisible(prevVisible => prevVisible + 6);
    }

    return (
        <Fragment>
            <section className="our-portfolio section_bg portfolio-two section-padding" id="portfolio">
                <Grid container spacing={3} className="websitePadding">
                    <Grid item xs={12} className="text-center">
                        <Grid className="theme-heading">
                            <span>Produkty</span>
                            <h2>Nasze Ostatnie Produkty</h2>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid className="portfolio-filter-buttons text-center">
                    <button className={`cBtn cBtnRadius cBtnUppercase ${category === '' ? 'active' : ''}`}
                            onClick={() => setCategory('',)}>Wszystkie
                    </button>
                    <button className={`cBtn cBtnRadius cBtnUppercase ${category === 'agency' ? 'active' : ''}`}
                            onClick={() => setCategory('gladki')}>Druty gładkie
                    </button>
                    <button className={`cBtn cBtnRadius cBtnUppercase ${category === 'creative' ? 'active' : ''}`}
                            onClick={() => setCategory('zebrowany')}>Druty żebrowane
                    </button>
                    <button className={`cBtn cBtnRadius cBtnUppercase ${category === 'design' ? 'active' : ''}`}
                            onClick={() => setCategory('spawany')}>Spawany metal
                    </button>
                </Grid>

                <Grid className="portfolio-grid-items">
                    {portfolio.filter(row => searchFilter(row, category)).slice(0, visible).map(item => {
                        return (
                            <Grid key={item.id} item md={4} sm={6} className="single-portofolio grid-item d-inline-block building bg-cover text-white"
                                  style={{backgroundImage: `url(${item.image})`}}>
                                <Grid className="portfolio-content">
                                    <h3>Working in new case</h3>
                                    <p>Excepteur sint occ aecat cupidatat non proident, sunt in culpa qui officia
                                        deserunt </p>
                                    <Grid className="portfolio-cat">
                                        <span>Building</span>
                                    </Grid>
                                    <Link to="/singleportfolio" className="read-more-port">READ MORE <i
                                        className="fas fa-arrow-right"></i></Link>
                                </Grid>
                            </Grid>
                        )
                    })}
                </Grid>
                <Grid className="ajax_load_btn text-center mt-60">
                    <button onClick={loadMoreHandler} className="theme_btn">WYŚWIETL WIĘCEJ</button>
                </Grid>
            </section>
        </Fragment>
    )
};
export default OurPortfolio;